export default "__VITE_ASSET__DfBsHr4r__"